'use strict';

var app = require('angular').module('app');

app.filter('range', require('./range'));